import { createI18n } from "vue-i18n";
import en from "./locales/en.json";

const i18n = createI18n({
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  globalInjection: true,
  messages: { en },
});

export const t = i18n.global.t;
export default i18n;
